export default __webpack_public_path__ + "static/media/Heart-Filled.26cff8a1.svg";